import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, theme } from "../../../theme";
import { Icon } from "../../../icon";
export const Checkbox = ({ size, className, checked, disabled, color, onChange, testId, Icon, ...props }) => (_jsxs(_Fragment, { children: [_jsx("input", { ...props, checked: checked, disabled: disabled, onChange: disabled ? undefined : onChange, "data-test-id": testId, hidden: true, type: "checkbox" }), _jsx(CheckboxIcon, { id: "checkbox-icon", className: className, size: size, color: color, checked: checked, disabled: disabled, children: checked && _jsx(Icon, { name: "check", color: theme.color.white }) })] }));
Checkbox.defaultProps = {
    checked: false,
    disabled: false,
    size: "normal",
    color: "primary",
    onChange: () => { },
    Icon,
};
const getCheckboxWidth = (size) => (size === "small" ? 1.2 : 1.5);
const CheckboxIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.3em;
  border: 2px solid ${({ theme, color }) => theme.color[color]};
  // Hack: min- values are required for flexbox sizing https://github.com/philipwalton/flexbugs/issues/184
  min-height: ${({ size }) => getCheckboxWidth(size)}em;
  min-width: ${({ size }) => getCheckboxWidth(size)}em;
  height: ${({ size }) => getCheckboxWidth(size)}em;
  width: ${({ size }) => getCheckboxWidth(size)}em;
  background-color: ${({ checked, color, theme }) => checked ? theme.color[color] : "transparent"};

  i {
    display: grid;
    font-size: 0.75em;
  }

  ${({ disabled, checked, theme }) => disabled &&
    `
      background-color: ${checked ? theme.color.gray100 : "transparent"};
      border-color: ${theme.color.gray100};
    `}
`;
